import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/all';

gsap.registerPlugin(ScrollTrigger);

export default {
  init() {

  },
  finalize() {

    // Animation for generic banner content box
    const $bannerGeneric = $('.banner-generic');

    if ($bannerGeneric.length > 0) {
      const contentBox = $bannerGeneric.find('.banner-content').get();

      gsap.fromTo(contentBox, {
        top: '20px',
        opacity: 0,
      }, {
        top: 0,
        opacity: 1,
        duration: 0.6,
        scrollTrigger: {
          trigger: $bannerGeneric.get(),
          start: 'top 40%',
        },
      });
    }

  },
}


// WEBPACK FOOTER //
// ./scripts/partials/other/banner.js